var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActivityTracker(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 79,
    viewBox: "0 0 89 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.47261 3.32786C4.47261 7.68294 2.8007 17.2183 8.95807 17.2183C15.9616 17.2183 18.3631 18.024 18.3631 10.8519C18.3631 9.52412 19.1646 2.0066 17.8807 1.63978C12.9429 0.228964 6.03903 1.59155 1 1.59155",
    stroke: "#FB7C51",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.47261 33.6809C4.47261 38.036 2.8007 47.5713 8.95807 47.5713C15.9616 47.5713 18.3631 48.3771 18.3631 41.2049C18.3631 39.8771 19.1646 32.3596 17.8807 31.9928C12.9429 30.582 6.03903 31.9446 1 31.9446",
    stroke: "#FB7C51",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.47261 64.0334C4.47261 68.3885 2.8007 77.9239 8.95807 77.9239C15.9616 77.9239 18.3631 78.7296 18.3631 71.5574C18.3631 70.2297 19.1646 62.7122 17.8807 62.3454C12.9429 60.9345 6.03903 62.2971 1 62.2971",
    stroke: "#FB7C51",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.354 37.1583C8.84859 38.7624 9.2083 40.5122 9.87498 42.0539C10.0875 42.5455 10.5058 41.8202 10.6355 41.6452C11.7631 40.1228 12.7605 38.5685 14.0672 37.1773C16.9397 34.1189 20.8915 31.8852 24.3432 29.5534C27.8957 27.1536 31.5507 24.9271 35.0471 22.4429",
    stroke: "#FB7C51",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.085 10.1229C31.1719 8.9589 32.276 7.80777 33.2885 6.57714C33.7139 6.06018 34.0766 5.39161 34.6099 4.97061C35.4297 4.32335 36.8222 3.37308 37.8704 3.12643C39.4656 2.75111 41.4237 5.97735 42.2528 6.83381C44.9253 9.59476 47.8701 11.5218 51.8729 11.1306C53.0456 11.0159 54.0696 10.5438 55.143 10.1039C56.8289 9.41297 58.5492 8.80886 60.2193 8.0791C61.2126 7.64504 62.1532 7.11015 63.1376 6.6627C63.8014 6.36096 64.624 7.08138 65.1054 7.42318C67.8603 9.37919 70.9849 12.0145 74.5735 10.7503C77.5929 9.68663 80.2946 7.94677 83.1289 6.52961",
    stroke: "#FB7C51",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.085 72.8124C31.1719 71.6483 32.276 70.4972 33.2885 69.2666C33.7139 68.7496 34.0766 68.0811 34.6099 67.6601C35.4297 67.0128 36.8222 66.0625 37.8704 65.8159C39.4656 65.4406 41.4237 68.6668 42.2528 69.5233C44.9253 72.2842 47.8701 74.2113 51.8729 73.82C53.0456 73.7054 54.0696 73.2333 55.143 72.7934C56.8289 72.1024 58.5492 71.4983 60.2193 70.7686C61.2126 70.3345 62.1532 69.7996 63.1376 69.3521C63.8014 69.0504 64.624 69.7708 65.1054 70.1126C67.8603 72.0686 70.9849 74.7039 74.5735 73.4398C77.5929 72.3761 80.2946 70.6362 83.1289 69.2191",
    stroke: "#FB7C51",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0049 42.121C29.3488 39.1351 31.6985 36.1601 34.1725 33.2803C34.9282 32.4006 35.1188 31.708 35.9501 32.729C38.7493 36.1666 41.3953 39.3551 45.9505 40.2958C47.0377 40.5203 48.2105 40.7698 49.3252 40.6665C51.7333 40.4436 53.7729 38.966 55.7513 37.7102C57.4103 36.6571 59.0719 35.73 60.8846 34.9724C61.7225 34.6222 61.7961 34.4809 62.3865 35.1435C65.133 38.2256 68.8936 39.1188 72.8908 39.5163C75.4661 39.7724 77.7445 39.6647 79.9538 38.1855C81.4398 37.1905 82.7707 35.9326 84.203 34.8583C85.0554 34.219 84.9506 36.0617 85.3532 36.5314C85.9138 37.1854 87.2512 35.0898 87.5777 34.7633",
    stroke: "#FB7C51",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivityTracker);
export default __webpack_public_path__ + "static/media/activityTracker.96e451d78f5e1cf6ca7c69abf2eb1f8d.svg";
export { ForwardRef as ReactComponent };